import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SubHeading, MenuItem } from '../../components';
import { data, images } from '../../constants';
import './SpecialMenu.css';

// Define animation variants
const fadeIn = {
    hidden: { opacity: 0, y: 20, scale: 0.9 },
    visible: { opacity: 1, y: 0, scale: 1 }
};

const SpecialMenu = () => {
    const [isVisible, setIsVisible] = useState(false);
    const menuRef = useRef(null);
    const menuItemsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {

                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    } else {
                        if (window.innerWidth >= 1151) {
                            setIsVisible(false);}
                    }
                });
            },
            { threshold: 0.1 ,
                rootMargin: "600px "
            } ,


        );

        if (menuRef.current) {
            observer.observe(menuRef.current);
        }

        return () => {
            if (menuRef.current) {
                observer.unobserve(menuRef.current);
            }
        };
    }, []);

    return (
        <div className="app__specialMenu flex__center section__padding" id="menu">
            <motion.div
                ref={menuRef}
                className="app__specialMenu-title"
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                variants={fadeIn}
                transition={{ duration: 1, ease: 'easeInOut' }}
            >
                <SubHeading title="Un menu qui vous ressemble" />
                <h1 className="headtext__cormorant2">Menu</h1>
            </motion.div>

            <motion.div
                className="app__specialMenu-menu"
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                variants={fadeIn}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
                <div className="app__specialMenu-menu_wine flex__center">
                    <motion.div
                        className="app__specialMenu_menu_items"
                        initial="hidden"
                        animate={isVisible ? "visible" : "hidden"}
                        variants={fadeIn}
                        transition={{ duration: 0.5, ease: 'easeInOut' }}
                    >
                        {data.menu.map((menu, index) => (
                            <MenuItem
                                key={menu.title + index}
                                title={menu.title}
                                price={menu.price}
                                tags={menu.tags}
                                ref={el => menuItemsRef.current[index] = el}
                            />
                        ))}
                    </motion.div>
                </div>

                <div className="app__specialMenu-menu_img">
                    <img className="top-right" src={images.bobun} alt="bobun"/>
                    <img className="top-middle" src={images.loclac} alt="loclac"/>
                    <img className="top-left" src={images.nouilles} alt="nouilles"/>
                    <img className="middle-right" src={images.nouilleSauter} alt="nouilleSauter"/>
                    <img className="middle-middle" src={images.pokebowl} alt="pokebowl"/>
                    <img className="middle-left" src={images.rizPoulet} alt="rizPoulet"/>
                    {/*<img className="bottom-right" src={images.vapeur} alt="vapeur"/>*/}
                    <img className="bottom-middle" src={images.vermicellePoulet} alt="vermicellePoulet"/>
                    <img className="bottom-left" src={images.padThai} alt="padThai"/>
                    {/*<img className="bottom-bottom" src={images.sushiCalifornia} alt="sushiCalifornia"/>*/}
                    {/* Additional images can be added here with appropriate classes */}
                </div>
            </motion.div>
        </div>
    );
};

export default SpecialMenu;
